import config from 'config';
import useAnchorLink from 'hooks/useAnchorLink';
import { TermsPageSectionId, TermsPageSource } from './types';

interface UseTermsPageHrefOptions {
  source?: TermsPageSource;
  sectionId?: TermsPageSectionId;
}

export function useTermsPageHref(options?: UseTermsPageHrefOptions) {
  const { source, sectionId } = options || {};

  let href = config.termsOfServiceUrl;

  const params = new URLSearchParams();

  if (source) {
    params.set('source', source);
  }
  if (sectionId) {
    params.set('scrollTo', sectionId);
  }

  const queryParams = params.toString();

  if (queryParams) {
    href = `${href}?${queryParams}`;
  }

  const result = useAnchorLink(href);

  return result;
}
